import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from "../ui/accordion";
import { ProtocolBody } from "./ProtocolCard";

export function ProtocolList({ protocols, open, onOpen, forLabel }) {
  return (
    <Accordion type="single" collapsible value={open || ""} onValueChange={onOpen} className="space-y-2">
      {protocols.map((p) => (
        <AccordionItem key={p.id} value={p.id} id={`emergency-${p.id}`} className="rounded-xl border border-red-200 bg-white px-4 border-b">
          <AccordionTrigger data-testid={`protocol-toggle-${p.id}`} className="hover:no-underline py-3.5">
            <span className="flex flex-col items-start text-left gap-0.5">
              <span className="font-heading font-semibold text-[#0B2545]">{p.title}</span>
              <span className="text-xs font-bold text-red-600">{p.short}{forLabel?.(p) ? <span className="font-medium text-slate-500"> · {forLabel(p)}</span> : null}</span>
            </span>
          </AccordionTrigger>
          <AccordionContent><ProtocolBody p={p} /></AccordionContent>
        </AccordionItem>
      ))}
    </Accordion>
  );
}
